import Footer from "../../components/common/layout/Footer";
import SEO from "@/components/common/seo/seo";
import { ItConsulting, Breadcrumbs, IntroSection, WhatWeDo, WhyChooseUs, OurProcess } from "@/components/features/itConsulting";

export default function ItServicePackage() {
    return(
        <div>
            <SEO
                title="Managed IT Proactive Support Services - SAN micron"
                description="Unlock seamless business operations with our Managed IT Proactive Support. We monitor, manage, and optimize your IT infrastructure to prevent issues, enhance security, and ensure maximum uptime for your business."
            />
            <Breadcrumbs />
            <IntroSection />
            <ItConsulting />
            <OurProcess />
            <WhyChooseUs />
            <WhatWeDo />
            <Footer />
        </div>
    );
}